<template>
  <div class="error_st">
    <div class="section full pb pt">
      <div class="inner">
        <img
          class="img_error er_404"
          src="@/assets/images/error_img.png"
          alt="error"
        />
        <div class="cont_wrap">
          <div class="an_a tit er_404">
            <img class="img" src="@/assets/images/svg/svg_404.svg" alt="404" />
            <span class="an_t">{{ $t('views.pagenotfound.1188') }}</span>
          </div>
          <h1 class="tit">{{ $t('views.pagenotfound.5252') }}</h1>
          <p class="tit">{{ $t('views.pagenotfound.3244') }}</p>
          <p class="txt">{{ $t('views.pagenotfound.7049') }}</p>

          <!--<div class="an_a txt er_404">
					<img class="img" src="../include/images/svg/svg_error_01.svg" alt="죄송합니다. 현재 페이지를 찾을 수 없습니다."/>
					<span class="an_t">{{ $t('views.pagenotfound.7933') }}</span>
				</div>
				<div class="an_a txt er_404">
					<img class="img" src="../include/images/svg/svg_error_02.svg" alt="요청하신 페이지가 사라졌거나, 잘못된 경로를 이용하셨습니다."/>
					<span class="an_t">{{ $t('views.pagenotfound.6991') }}</span>
				</div>
				<div class="an_a txt er_404">
					<img class="img" src="../include/images/svg/svg_error_02_m.svg" alt="요청하신 페이지가 사라졌거나, 잘못된 경로를 이용하셨습니다."/>
					<span class="an_t">{{ $t('views.pagenotfound.5700') }}</span>
				</div>-->
          <div class="btn_wrap">
            <div class="bdsi_f2">
              <router-link :to="{ name: 'store' }" class="box_btn dull"
                ><span class="an_t">{{
                  $t('views.pagenotfound.6313')
                }}</span></router-link
              >
            </div>
            <div class="bdsi_f2">
              <a class="box_btn" @click="$router.go(-1)"
                ><span class="an_t">{{
                  $t('views.pagenotfound.9487')
                }}</span></a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageNotFound'
}
</script>
<style src="@/assets/css/page_error.css" scoped></style>
<style lang="scss" scoped>
.img {
  @media (min-width: 768px) {
    margin: 0 auto 0 0;
  }
}
</style>
